// extracted by mini-css-extract-plugin
export default {"wiseBreadcrumbsContainer":"WiseBreadcrumbs_wiseBreadcrumbsContainer__O6vfA","wiseBreadcrumbsPanel":"WiseBreadcrumbs_wiseBreadcrumbsPanel__1xZOc"};